"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _party = _interopRequireDefault(require("./1-party"));

var _guild = _interopRequireDefault(require("./2-guild"));

var _friends = _interopRequireDefault(require("./3-friends"));

var _mercenaries = _interopRequireDefault(require("./4-mercenaries"));

var _crafting = _interopRequireDefault(require("./5-crafting"));

var _bank = _interopRequireDefault(require("./6-bank"));

var _privateShop = _interopRequireDefault(require("./7-privateShop"));

var _quests = _interopRequireDefault(require("./8-quests"));

var _pvp = _interopRequireDefault(require("./9-pvp"));

var _command = _interopRequireDefault(require("./10-command"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var system = {
  id: "system",
  title: {
    en: "System",
    de: "System"
  },
  chapters: [_party.default, _guild.default, _friends.default, _mercenaries.default, _crafting.default, _bank.default, _privateShop.default, _quests.default, _pvp.default, _command.default]
};
var _default = system;
exports.default = _default;